'use client';

import { SalePageComments } from '@/app/sales/components/comments';
import {
  useSalePageCommentsCountQuery,
  useSalePageCommentsPreviewQuery,
} from '@/entities/salePage';

interface SalePageCommentsFetcherProps {
  salePageId: number;
}

export const SalePageCommentsFetcher = ({
  salePageId,
}: SalePageCommentsFetcherProps) => {
  const commentsCountQuery = useSalePageCommentsCountQuery(salePageId);
  const commentsQuery = useSalePageCommentsPreviewQuery(salePageId);

  return (
    <SalePageComments
      salePageId={salePageId}
      commentsCount={commentsCountQuery.data ?? 0}
      comments={commentsQuery.data?.list ?? []}
    />
  );
};
